import { Model } from '@viddsee/server-api-client';
import Vue, { VNode } from 'vue';
import PscManager from '@/scripts/pages/video/VideoTrackers/Psct/PscManager.ts.vue';

export const TRACKER_DOM_ID = 'psct-vue-mount-point';

/**
 * Create mount point if doesn't exist.
 * Otherwise, if mount point already exist, destroy any bound vue instance and return the existing mount point
 */
const prepareElement = (mountId: string): HTMLDivElement => {
  const existingEl = document.getElementById(mountId);
  if (existingEl) {
    (existingEl as any).__vue__ && (existingEl as any).__vue__.$destroy();
    return existingEl as HTMLDivElement;
  }

  const el = document.createElement('div');
  el.setAttribute('id', mountId);
  document.body.appendChild(el);
  return el;
};

export const addPscTracker = (
  video: Model.Video.Info,
  player: jwplayer.JWPlayer,
  sandboxUrl?: string,
  mountId = TRACKER_DOM_ID,
): any => {
  if (!video.isPsct) return;

  const el = prepareElement(mountId);

  return new Vue({
    el,
    render: (h): VNode => h(PscManager, {
      props: {
        video,
        player,
        sandboxUrl,
      },
    }),
  });
};
